import AssociationContactDetails from './AssociationContactDetails.page';

export default AssociationContactDetails;